export function exitDemoMode(rootElement: HTMLDivElement): void
{
    rootElement.classList.remove("hide-overflow");
}